import React from 'react';

export interface SparklineProps {
  data: number[];
  w?: number;
  h?: number;
  color: string;
  fill?: string;
  strokeW?: number;
}

export const Sparkline: React.FC<SparklineProps> = ({
  data,
  w = 120,
  h = 32,
  color,
  fill,
  strokeW = 1.5,
}) => {
  const max = Math.max(...data);
  const min = Math.min(...data);
  const range = max - min || 1;
  const denom = Math.max(data.length - 1, 1);
  const pts = data.map((v, i) => [(i / denom) * w, h - ((v - min) / range) * h]);
  const d = pts
    .map((p, i) => `${i === 0 ? 'M' : 'L'}${p[0].toFixed(1)},${p[1].toFixed(1)}`)
    .join(' ');
  const area = `${d} L${w},${h} L0,${h} Z`;
  return (
    <svg width={w} height={h} className="block">
      {fill ? <path d={area} fill={fill} opacity={0.25} /> : null}
      <path
        d={d}
        fill="none"
        stroke={color}
        strokeWidth={strokeW}
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
};
